module.exports = __webpack_public_path__ + "img/66.6063d8e1.png";